import superagent from 'superagent'

export const linesSet = lines => ({
  type: 'LINES_SET',
  payload: lines
})

export const lineCreate = line => ({
  type: 'LINE_CREATE',
  payload: line
})

export const lineUpdate = line => ({
  type: 'LINE_UPDATE',
  payload: line
})

export const lineDelete = id => ({
  type: 'LINE_DELETE',
  payload: id
})

// Lines arrive through the one changes sweep in changes-last-called-actions.js, which dispatches
// linesSet itself. The lineFetchRequest/callChanges pair that used to live here was an orphaned
// second sweep of the entire changes feed from asOfDate=2000 - unreferenced by any component, no
// re-entrancy guard, no error handling - and was removed rather than hardened (WEB-7062).

export const lineCreateRequest = lineObj => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .post(`${__API_URI__}/measurement/create`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(lineObj))
      .end((err, res) => {
        if (err) {
          return reject(err);
        }
        Countly.q.push([
          'add_event',
          {
            key: 'Create Line',
            count: 1,
          },
        ]);

        if (res.body.photoId) {
          // Fetch photo details based on photoId
          $.ajax({
            method: 'GET',
            url: `${__API_URI__}/photo/get/${res.body.photoId}`,
            headers: {
              Authorization: `Bearer ${token}`,
              Platform: 'Web',
              Version: `${__version__}`,
            },
          })
            .done((photoRes) => {
              // Add the photo data to the main response body
              res.body.photo = photoRes;

              // Dispatch the circle creation with the updated payload
              dispatch(lineCreate(res.body));
              resolve(res.body);
            })
            .fail((ajaxErr) => {
              console.error('Error fetching photo details:', ajaxErr);
              reject(ajaxErr);
            });
        } else {
          // Directly dispatch if no photoId is present
          dispatch(lineCreate(res.body));
          resolve(res.body);
        }
      });
  })
}

export const lineUpdateRequest = lineObj => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .put(`${__API_URI__}/measurement/update`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(lineObj))
      .end((err, res) => {
        if (err) {
          reject(err)
          if (err.status == 401) {
            return err.status
          }
        } else {
          if (res.photoId) {
            $.ajax({
              method: 'GET',
              url: `${__API_URI__}/photo/get/${res.photoId}`,
              headers: {
                Authorization: `Bearer ${token}`,
                Platform: 'Web',
                Version: `${__version__}`
              }
            }).done(res => {
              res.photo = res
            })
          }
          dispatch(lineUpdate(res.body))
        }
        resolve(res.body)
      })
  })
}

// Rejects with the superagent error when the delete fails (WEB-7103), and only then leaves the
// object in the store; it's removed once the server confirms.
export const lineDeleteRequest = id => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .delete(`${__API_URI__}/measurement/delete/${id}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) return reject(err)
        dispatch(lineDelete(id))
        resolve(res.body)
      })
  })
}
